import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../alert/alert.component';
declare var $: any;
import * as _ from 'lodash';
import * as moment from 'moment';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';
@Component({
  selector: 'app-agenda-search',
  templateUrl: './agenda-search.component.html',
  styleUrls: ['./agenda-search.component.css']
})
export class AgendaSearchComponent implements OnInit {

  public environmentSettings: any;
  public downloadSingleFile: string;
  isSearchDivVisible = false;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtMeetingList: DataTables.Settings = {};
  dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  meetingArray: any[];
  loadedAgendaFiles: any = {meetingId: "", loadedAgendaFilesArray: []};
  meetingType: any[];
  selectedMeeting: any = null;
  meetingDateModel: any;
  meetingIdToDelete: any;
  response: boolean;
  availableList: any[];
  typeHasError: boolean = true;
  agendaDocsToUpload: Array<File>;
  indexDocsToUpload: Array<File>;
  uploadDoc: boolean = false;
  FileOrignalName: any;
  changedName: any;
  templateFileName: any;
  templateDocId = '';
  public downloadAllLink: string = "documentManagement/downloadSingleFileOnID/";
  indexTemplateFileName: any;
  indexTemplateDocId = '';
  uploadIndexDoc: boolean = false;
  type = '';
  IsSequenseMeetingNumber:any;
  agendaData: any[];
  agendaNumberSearchParm: any;
  meetingTypes: any[]
  localStorageCompanyId:any;
  agendaList:any;
  list = [];
  fileTypechk:any;
  fileUrl:any;
  g_searchAgendaObject: any = {
    MeetingTypeID: ""
  };
  searchedData: any[] = [];
  constructor(private meetingService: MeetingMasterService,
    private commonFunction: CommonFunction,
    private renderer: Renderer2,
    private alert: AlertComponent) {
    this.response = false;
  }


  ngOnInit() {

    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });

    this.environmentSettings = environment;
    this.commonFunction.validateURL('Meetings', '');
    let searchflag = localStorage.getItem('searchmeetingflag');
    //console.log("searchflag",searchflag);
    this.dtMeetingList = {
      processing: true,
      destroy: true,
      scrollY: "300px",
      scrollCollapse: true,
      scrollX: true,
      deferRender: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      stateSave: false,
      serverSide: false,
      stateDuration: -1,
      search: true,
      language: {searchPlaceholder: "Search Agenda Title..." },
      order: [[1, 'asc']],
      // order: [[2, 'asc'], [3, 'asc']],
      columnDefs: [{ orderable: false, targets: null }],
     columns:[{searchable: false},{searchable: false},{searchable:true}, {searchable: false},{searchable: false},{searchable: false}],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Agenda Search List',
          title: 'Agenda Search List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 4,5],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          },
        }
      ]
    };
    //this.getAgendaList();
    this.getMeetingType();
     this.getMeetingAgendaList();
    this.meetingDateModel = null;
    this.meetingsSearch = null;
  }
 
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }

  isPssToshowMenu(type) {
    if (type == 'width') {
      if (!this.environmentSettings.PSS) {
        return '20%'
      } else {
        return ''
      }
    } else {
      if (!this.environmentSettings.PSS) {
        return 'Status'
      } else {
        return ''
      }
    }

  }
  clearAdvSearchResult() {
    this.meetingArray = [];
    this.response = true;
    this.meetingsSearch = '';
    this.meetingsSearchDateFrom = null;
    this.meetingsSearchDateTo = null;
    this.selectedMeeting = '';
    this.getMeetingAgendaList();
  }
  openPdf(docId, meetingId,docName, filetype){
    
    let file = docName;
    this.fileTypechk = (file).substr(-3)
    
    if(this.fileTypechk != "pdf"){
      this.alert.error('Only PDF can be viewed');
    }
   else{
    var token = localStorage.getItem('token')
    this.meetingService.getAttendanceFileName(docId).then(response => {
       var url  =   environment.PSSFileNotValidurl + '/' +'documentManagement/getFileById' + '/' + docId  + '/' + token ;
      //  console.log('response', url )
      window.open(url, '_blank');
    })
   }
  }
  advFilterSearch(){
    this.meetingArray = [];
    this.response = true;
  var paramData = {
      'MeetingTypeID': this.selectedMeeting,
      '_id': this.meetingsSearch,
      'meetingFrom': this.setDate(this.meetingsSearchDateFrom),
      'meetingTo': this.setDate(this.meetingsSearchDateTo),
    }
    this.meetingArray = [];
    var table = $('#agendaTable').DataTable({ destroy: true });
    table.destroy();
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var companyId = companyDetails.companyID;  
    this.meetingService.getMeetingAgendaList(companyId)
      .subscribe(meetingList => {
        if (meetingList.status == 0) {
          this.meetingArray = meetingList.data;
          let filterData = this.meetingArray.filter(function (currentElement) {
            // console.log(currentElement)
          let meetingDate = moment(currentElement.MeetingDate).utc().format('YYYY-M-D')
          // console.log(meetingDate, 'converted Date')
            // if(paramData._id != null && paramData.MeetingTypeID != null && paramData.meetingFrom == null && paramData.meetingTo == null){
            //   if (currentElement.meetingID == paramData._id) {
            //     return true;
            //   }
            // }
            if(paramData.MeetingTypeID != null && paramData.meetingFrom == null && paramData.meetingTo == null){
              if (currentElement.MeetingTypeID == paramData.MeetingTypeID) {
                return true;
              }
            }
            if(paramData.MeetingTypeID == null && paramData.meetingFrom != null && paramData.meetingTo != null){
              if (meetingDate >= paramData.meetingFrom && meetingDate <= paramData.meetingTo) {
                return true;
              }
            }
            if(paramData.MeetingTypeID != null && paramData.meetingFrom != null && paramData.meetingTo != null){
              if (currentElement.MeetingTypeID == paramData.MeetingTypeID && meetingDate >= paramData.meetingFrom && meetingDate <= paramData.meetingTo) {
                return true;
              }
            }
          });
          
          this.meetingArray = filterData;
          this.response = false;
          // console.log(this.meetingArray);
        }
        this.dtTrigger.next();
      })
  }
  getMeetingAgendaList() {
    var companyID = "5a69d939e956200fa005f2f3";
    this.meetingArray = [];
    var table = $('#agendaTable').DataTable({ destroy: true });
    table.destroy();
    var self = this;
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    //console.log("companyDetails",companyDetails);
    var companyId = companyDetails.companyID;
    //console.log("companyId",companyId);
    // this.meetingArray = new Array<any>();    
    this.meetingService.getMeetingAgendaList(companyId)
      .subscribe(meetingList => {
        //console.log("meetingList",meetingList);
        if (meetingList.status == 0) {
          this.meetingArray = meetingList.data;
          this.response = false;
          // console.log(this.meetingArray);
          
        }
     
        this.dtTrigger.next();
      })
  }
  getMeetingsByType(meetingTypeID) {
    this.meetingService.getMeetingListByType(meetingTypeID)
      .subscribe(meetingList => {
        if (meetingList.status == 0) {
          var table = $('#agendaTable').DataTable({ destroy: true });
          table.destroy();
          this.meetingArray = meetingList.meetingData;
          this.dtTrigger.next();
        }
      })
  }
  minDateForSearchFrom: NgbDateStruct;
  minDateForSearchTo: NgbDateStruct;
  todayDateforSearchMeeting: NgbDateStruct;
  meetingsSearchDateFrom: NgbDateStruct;
  meetingsSearchDateTo: any;
  /*  
   * On select of meeting date from in search box.
   */
  meetingDateSearchMeeting() {
    var dateObj = new Date();
    this.todayDateforSearchMeeting = { year: dateObj.getUTCFullYear(), month: dateObj.getUTCMonth() + 1, day: dateObj.getUTCDate() };
    this.minDateForSearchTo = this.meetingsSearchDateFrom;
  }
  getMeetingBetweenDates(searchParam) {
    this.meetingService.getMeetingBetweenDates(searchParam)
      .subscribe(meetingList => {
        //console.log("meetingTypeList",meetingList)  ;
        if (meetingList.status == 0) {
          var table = $('#agendaTable').DataTable({ destroy: true });
          table.destroy();
          this.meetingArray = meetingList.meetingData;
          this.dtTrigger.next();
        }
      })
  }
  getMeetingType() {
    this.meetingService.getMeetingTypeList()
      .subscribe(meetingTypeList => {
        //console.log("meetingTypeList",meetingTypeList)  ;
        if (meetingTypeList.status == 0) {
          this.meetingType = meetingTypeList.meetingTypeList;
          this.meetingType = this.commonFunction.sortByKey(this.meetingType, 'MeetingType');
          //this.dtTrigger.next();
        }
      })
  }

  meetingsSearch: any;
  meetingDateOnSelectedType: any[];
  getMeetingFromType() {
    this.meetingsSearch = null
    this.meetingsSearch = null;
    this.meetingService.getMeetingOnTypeSelect(this.selectedMeeting).subscribe(data => {

      if (data.meetingData.length > 0) {
        if (data.status == 0) {
          var meetingData = data.meetingData;
          this.meetingDateOnSelectedType = [];

          meetingData.forEach(element => {
            element.meetingList.MeetingDate = new Date(element.meetingList.MeetingDate);
          });

          meetingData = _.sortBy(meetingData, function (value) {
            return new Date(value.meetingList.MeetingDate);
          });

          meetingData.forEach(element => {
            var todayDate = new Date();
            var meetingDate = element.meetingList.MeetingDate

            if (moment(todayDate).diff(moment(meetingDate).format('YYYY-MM-DD'), "days") <= 0) {
              //console.log(moment(todayDate).format('YYYY-MM-DD'),'TodaysDate-----meetingDate', moment(meetingDate).format('YYYY-MM-DD'));
              this.meetingDateOnSelectedType.push(element);

            }
          });
          // meetingData=_.sortBy(meetingData, 'MeetingDate');

        }
      } else {
        this.meetingDateOnSelectedType = []
      }
    });
  }
  downloadFile(downloadingFileID) {
    //console.log((downloadingFileID);
    var token = localStorage.getItem('token')
    window.location.href = environment.pssServerUrl + this.downloadAllLink + downloadingFileID + "/" + token;
  }
  downloadAgendaDocs(meetingID, agendaId, type) {
    var token = localStorage.getItem('token')
    this.meetingService.generateKeyBeforDownloadingDocument(meetingID, agendaId, type);
  }
  getMeetingByDate(meetingDateModel) {
    this.meetingService.getMeetingByDate(meetingDateModel)
      .subscribe(meetingList => {
        if (meetingList.status == 0) {
          var table = $('#agendaTable').DataTable({ destroy: true });
          table.destroy();
          this.meetingArray = meetingList.meetingData;
          this.dtTrigger.next();
        }
      })
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.year + "-" + date.month + "-" + date.day;
    }
    return null;
  }


  //Multiple Documents were enabled from Add Meeting Page, which were stored in AgendaFileArray
  //IN Ageda Search Screen also the changes needs to be made to consider the new file location of AgendaFileArray instead of AgendaFile

  //If there is File in AgendaArray Then it will add that in AgendaFileArray if not previously added
  //Then this function will open a modal for multple file download.
  sycnAgendaFileandAgendaFileArrayAndOpenDownloadModal(meetingId) {

    //Fetching meeting from meeting id
    var meeting  = this.meetingArray.find(meeting => {return meeting.meetingID == meetingId});

    //Reading AgendaFile and AgendaFileArray from meeting
    var agendaFile = {...meeting.Documents.agendaFile};
    var agendaFileArray = [...meeting.Documents.agendaFileArray];

    var agendaFile_docId = null;
    if(agendaFile && agendaFile.docId) {// IF Agenda File has any data
      agendaFile_docId = agendaFile.docId;
      if(agendaFileArray.filter(af => {return af.docId == agendaFile_docId}).length == 0) { //Data in AgendaFile not in AgenadFileArray
        agendaFileArray.push(agendaFile);
      }
    }
    
    //loadedAgendaFiles; >> the updated agenda file array needs to be pushed here to be iterated in html Popup/Modal
    this.loadedAgendaFiles.loadedAgendaFilesArray = [...agendaFileArray];
    this.loadedAgendaFiles.meetingId = meetingId;

    //Open the download agenda Popup
    $("#AgendaSearchFileDialoge").modal("toggle");
  }

  //Function to simple download the file from ID
  downloadDoc(data) {
    var token = localStorage.getItem('token')
    this.downloadSingleFile = environment.pssServerUrl + 'documentManagement/downloadSingleFileOnID/';
    window.location.href = this.downloadSingleFile + data + "/" + token;
  }


}
